export default function Footer() {
  const quick = [
    { label: "今日炸点", href: "#today" },
    { label: "栏目瓜田", href: "#columns" },
    { label: "事件盘点", href: "#feed" },
    { label: "全网围观榜", href: "#ranking" },
    { label: "吃瓜锦囊", href: "#faq" },
    { label: "关于我们", href: "#about" },
  ];
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:px-6 md:grid-cols-[1.4fr_1fr_1.2fr]">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-primary-950">
              <i className="ri-fire-fill text-lg leading-none" aria-hidden="true"></i>
            </span>
            <span className="text-lg font-black tracking-tight text-background-50">
              吃瓜<span className="text-accent-300">爆网</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
            每日更新全网热门爆点事件与今日炸点，实时追踪全网围观话题。以冷静的视角、
            清晰的整理，把纷繁的热点一网打尽，陪你直击每一场全网都在聊的瓜田现场。
          </p>
          <div className="mt-5 flex gap-2">
            {["ri-wechat-line", "ri-weibo-line", "ri-tiktok-line", "ri-douban-line"].map((i) => (
              <a
                key={i}
                href="#about"
                aria-label="社交平台入口"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950"
              >
                <i className={`${i} text-base`} aria-hidden="true"></i>
              </a>
            ))}
          </div>
        </div>

        <nav aria-label="站点导航">
          <h3 className="text-sm font-bold tracking-wide text-background-50">快速导航</h3>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {quick.map((q) => (
              <li key={q.href}>
                <a href={q.href} className="text-sm text-background-200 transition-colors hover:text-accent-300 whitespace-nowrap">
                  {q.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="text-sm font-bold tracking-wide text-background-50">联系我们</h3>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            有线索想分享，或对栏目有建议？欢迎来信，我们会在 24 小时内回复。
          </p>
          <a
            href="mailto:contact@chigua-baowang.example.com"
            className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-accent-300 transition-colors hover:text-background-50"
          >
            <i className="ri-mail-line" aria-hidden="true"></i>
            contact@chigua-baowang.example.com
          </a>
          <p className="mt-4 text-xs leading-relaxed text-background-300">
            吃瓜有度，求证为先。本站内容仅供信息参考与讨论，不构成对任何事件的定性与结论。
          </p>
        </div>
      </div>
      <div className="border-t border-primary-800">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-300 sm:flex-row md:px-6">
          <p>© 2026 吃瓜爆网 · 每日更新全网热门事件与今日炸点</p>
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-fire-line text-accent-300" aria-hidden="true"></i>
            今日炸点 · 全网围观 · 一网打尽
          </p>
        </div>
      </div>
    </footer>
  );
}